// @generated by protobuf-ts 2.8.2 with parameter output_javascript
// @generated from protobuf file "zammad.proto" (syntax proto3)
// tslint:disable
import { ZammadService } from "./zammad";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * Zammad ticketing service for Kalos
 *
 * @generated from protobuf service ZammadService
 */
export class ZammadServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = ZammadService.typeName;
        this.methods = ZammadService.methods;
        this.options = ZammadService.options;
    }
    /**
     * Create a new support ticket in Zammad
     *
     * @generated from protobuf rpc: CreateTicket(CreateTicketRequest) returns (CreateTicketResponse);
     */
    createTicket(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Create a ticket using a JWT token (public endpoint, no authentication required)
     *
     * @generated from protobuf rpc: CreateTicketWithToken(CreateTicketWithTokenRequest) returns (CreateTicketResponse);
     */
    createTicketWithToken(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Get available groups for ticket assignment
     *
     * @generated from protobuf rpc: GetGroups(GetGroupsRequest) returns (GetGroupsResponse);
     */
    getGroups(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Get available ticket priorities
     *
     * @generated from protobuf rpc: GetPriorities(GetPrioritiesRequest) returns (GetPrioritiesResponse);
     */
    getPriorities(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Get available ticket states
     *
     * @generated from protobuf rpc: GetStates(GetStatesRequest) returns (GetStatesResponse);
     */
    getStates(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * Health check for Zammad connectivity
     *
     * @generated from protobuf rpc: HealthCheck(HealthCheckRequest) returns (HealthCheckResponse);
     */
    healthCheck(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
